// src/config/authConfig.js

export const authConfig = {
  clientId: 'react-app',
  authorizationEndpoint: 'https://31.97.206.87:8443/realms/family-dunia/protocol/openid-connect/auth',
  logoutEndpoint: 'https://31.97.206.87:8443/realms/family-dunia/protocol/openid-connect/logout',
  tokenEndpoint: 'https://31.97.206.87:8443/realms/family-dunia/protocol/openid-connect/token',
  redirectUri: 'https://familyduniya-dev.censeotech.com',
  scope: 'profile openid',
  decodeToken: true,
  autoLogin: false,
  pkce: true
};

export const REDIRECT_URI = authConfig.redirectUri;
export const LOGOUT_ENDPOINT = authConfig.logoutEndpoint;